import { render, staticRenderFns } from "./EquipItem_v2.vue?vue&type=template&id=0d2e7388&"
import script from "./EquipItem_v2.vue?vue&type=script&lang=js&"
export * from "./EquipItem_v2.vue?vue&type=script&lang=js&"
import style0 from "./EquipItem_v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports